import store from "@/store"

export default (to, from, next) => {
  if (
    store.getters["identity/getIsUserLoggedIn"] &&
    to.matched.some(record => record.meta.authRedirect)
  ) {
    return next({ path: "/account" })
  }
  next()
}
